/* eslint-disable no-case-declarations */
import { Avatar, List, Spin, Typography } from 'antd';
import dayjs from 'dayjs';
import { memo, useEffect, useState } from 'react';
import DeviceService from 'src/services/device.service';
import NotificationService from 'src/services/notification.service';
import { ENotificationType, INotification } from 'src/types';
import { CONTANTS, EVENTS, FUNCS, MESSAGE } from 'src/utils';

interface IProps {
  onClose: () => void;
  newItem?: INotification;
}

interface IState {
  data: INotification[];
  loading: boolean;
  page: number;
  total: number;
}

const initState: IState = {
  data: [],
  loading: false,
  page: 1,
  total: 0,
};

const sv = new NotificationService();
const svDevice = new DeviceService();

function NotificationPopover(props: IProps) {
  const [state, setState] = useState<IState>(initState);
  // const { account } = useAccount();
  // const navigate = useNavigate();

  useEffect(() => {
    if (props.newItem) {
      setState((prev) => ({ ...prev, data: [props.newItem as INotification, ...prev.data] }));
    }
  }, [props.newItem]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    if (state.loading) return;
    setState((prev) => ({ ...prev, loading: true }));
    try {
      const res = await sv.list({ take: CONTANTS.PAGE_SIZE_MAX });

      setState((prev) => ({ ...prev, data: res.data }));
    } catch (error) {
      console.log(error);
    }
    setState((prev) => ({ ...prev, loading: false }));
  };

  // const onLoadMore = async () => {
  //   try {
  //     const res = await sv.list({
  //       limit: 10,
  //       page: state.page + 1,
  //       fields: [
  //         'id',
  //         'subject',
  //         'message',
  //         'status',
  //         'collection',
  //         'item',
  //         'sender.first_name',
  //         'sender.last_name',
  //         'sender.avatar',
  //         'timestamp',
  //       ],
  //       filter: {
  //         recipient: { _eq: user?.id },
  //         // collection: { _neq: ECollection.conversation },
  //       },
  //       sort: ['-timestamp'],
  //     });

  //     setState((prev) => ({ ...prev, data: [...prev.data, ...res], page: prev.page + 1 }));
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const onGoDetail = (item: INotification) => {
    if (item.type === ENotificationType.SHARE && item.seen === 0) {
      onConfirmAcceptShare(item);
    }
    // props.onClose();
    if (item.seen === 0) {
      sv.seen(item.id);
    }
  };

  const onConfirmAcceptShare = (item: INotification) => {
    EVENTS.onShowModalConfirm({
      title: 'Chấp chận chia sẻ',
      content: `Bạn chắc chắn muốn chấp chận chia sẻ thiết bị này không?`,
      onOk: () => onAcceptShare(item),
    });
  };

  const onAcceptShare = async (item: INotification) => {
    try {
      const res = await svDevice.acceptShare(item.reference_id as string);
      if (res) {
        MESSAGE.success('Chấp chận chia sẻ thiết bị thành công!');
        props.onClose();
      }

      return true;
      // setState((prevState) => ({ ...prevState, showModalUpdateAutoGPS: false }));
    } catch (error) {
      console.log(error);
    }

    return false;
  };

  return (
    <div style={{ marginTop: -6, width: 460 }}>
      <Spin spinning={state.loading}>
        <List
          dataSource={state.data}
          renderItem={(item) => (
            <List.Item
              key={item.id}
              style={{ cursor: 'pointer' }}
              onClick={() => onGoDetail(item)}
              className="noti-list-item"
            >
              <List.Item.Meta
                avatar={<Avatar size={48} src={FUNCS.getFullUrl(item.user_sender?.avatar)} />}
                title={
                  <div>
                    <strong>{item.title}</strong>{' '}
                    <Typography.Text style={{ fontWeight: 400, fontSize: 10 }} type="secondary">
                      {dayjs(item.created_at).fromNow()}
                    </Typography.Text>
                  </div>
                }
                description={`${item.user_sender?.fullname} ${item.content}`}
              />
              {item.seen !== 1 && <div className="unseen-dot" />}
            </List.Item>
          )}
        />
      </Spin>
    </div>
  );
}

export default memo(NotificationPopover);
